import React, { memo, HTMLProps } from 'react';
import classnames from 'classnames';
import styles from './title.module.scss';
import Element from '../../element';

interface IProps extends HTMLProps<HTMLAnchorElement> {
    className?: string;
    children: React.ReactNode;
    size?: 1 | 2 | 3 | 4 | 5 | 6;
    subtitle?: boolean;
    weight?: 'light' | 'normal' | 'semibold' | 'bold';
    renderAs?: string;
    spaced?: boolean;
    heading?: boolean;
}

function Title(props: IProps) {
    const {
        renderAs = 'h3',
        children,
        className,
        size,
        subtitle,
        weight,
        spaced,
        heading,
        ...rest
    } = props;
    return (
        <Element
            renderAs={renderAs}
            className={classnames(className, {
                [styles.title]: !subtitle && !heading,
                [styles.subtitle]: subtitle,
            })}
            {...rest}
        >
            {children}
        </Element>
    );
}

export default memo(Title);
